<app-layout>
  <div class="main">
    <div class="header-table">
      <div class="title">
        <app-titulo>Motoristas</app-titulo>
      </div>
      <div class="header-buttons">
        <app-botao
          type="upload"
          class="button"
          text="Atualizar Termo de Uso"
          icon="assets/add-excel.svg"
          (fileSelected)="uploadTermo($event, 1)"></app-botao>
        <app-botao
          type="secundario"
          class="button"
          title="Download Termo de Uso"
          icon="assets/exportar-excel.svg"
          (click)="downloadArquivo(1)"></app-botao>
        <app-botao
          type="upload"
          class="button"
          text="Atualizar Termo de Consentimento"
          icon="assets/add-excel.svg"
          (fileSelected)="uploadTermo($event, 2)"></app-botao>
        <app-botao
          type="secundario"
          class="button"
          title="Download Termo de Consentimento"
          icon="assets/exportar-excel.svg"
          (click)="downloadArquivo(2)"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Motoristas Externos <br /></div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getMotoristas()">
            <div class="table-filters">
              <app-input
                label="Nome Motorista"
                width="100%"
                placeholder="Pesquisar"
                name="NM_MTRT_EXTR"
                formControlName="NM_MTRT_EXTR"></app-input>
              <app-input
                label="CPF Completo"
                width="100%"
                placeholder="Pesquisar"
                name="TX_CPF_EXTR"
                formControlName="TX_CPF_EXTR"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Nome Motorista"
        width="100%"
        placeholder="Pesquisar"
        name="NM_MTRT_EXTR"
        formControlName="NM_MTRT_EXTR"></app-input>
      <app-input
        label="CPF Completo"
        width="100%"
        placeholder="Pesquisar"
        name="TX_CPF_EXTR"
        formControlName="TX_CPF_EXTR"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
